import { Component, OnInit } from '@angular/core';
import { ModalController, PopoverController } from '@ionic/angular';
import { UnfocusElementService } from 'src/app/services/unfocus-element.service';
import { ReplaceMediaPopoverComponent } from './../../popovers/replace-media-popover/replace-media-popover.component';

@Component({
  selector: 'app-confirm-replace-media-modal',
  templateUrl: './confirm-replace-media-modal.page.html',
  styleUrls: ['./confirm-replace-media-modal.page.scss'],
})
export class ConfirmReplaceMediaModalPage implements OnInit {

  constructor(
    public modalController: ModalController,
    public popoverController: PopoverController,
    public unfocusService: UnfocusElementService,
  ) { }

  ngOnInit() {
  }

  closeModal(){
    this.modalController.dismiss();
  }

  closeModalAndSendData(event, option: string){
    var data = { event: event, option: option };
    this.modalController.dismiss(data);
  }

  async showInfoPopover(event, option: string = ""){
    this.unfocusService.unfocus(event);
    const popover = await this.popoverController.create({
      component: ReplaceMediaPopoverComponent,
      componentProps: { option: option },
      event: event,
      translucent: true,

    });

    return await popover.present();
  }

}
